/**
 * Public discussion boards (/diskusie). One topic per main GROWNi section; icons and colors
 * mirror the nav bar in `app/components/header/HeaderNew.vue`.
 */

/**
 * Launch switch. While false the boards work but stay unlisted: no homepage section or section
 * teasers, no sitemap entries, and `noindex` on every page.
 */
export const DISCUSSIONS_LAUNCHED = true

export const DISCUSSION_TOPICS = [
    {
        id: 'mentoring',
        label: 'Mentoring',
        description: 'Hľadanie mentora, mentorské vzťahy a ako z nich vyťažiť čo najviac.',
        icon: 'mentoring',
        color: '#047274',
        darkColor: '#4AD8DC',
        bgColor: 'rgba(4,114,116,0.1)'
    },
    {
        id: 'dobrovolnictvo',
        label: 'Dobrovoľníctvo',
        description: 'Dobrovoľnícke projekty, neziskovky a ako pomáhať zmysluplne.',
        icon: 'volunteering',
        color: '#eab308',
        darkColor: '#eab308',
        bgColor: 'rgba(234,179,8,0.1)'
    },
    {
        id: 'praca',
        label: 'Práca & Stáže',
        description: 'Hľadanie práce a stáží, pohovory a prvé kroky v kariére.',
        icon: 'jobs',
        color: '#f97316',
        darkColor: '#f97316',
        bgColor: 'rgba(249,115,22,0.1)'
    },
    {
        id: 'vzdelavanie',
        label: 'Vzdelávanie',
        description: 'Škola, kurzy, nové zručnosti a ako sa učiť popri všetkom ostatnom.',
        icon: 'skills',
        color: '#c24cfc',
        darkColor: '#c24cfc',
        bgColor: 'rgba(194,76,252,0.1)'
    },
    {
        id: 'sebapoznanie',
        label: 'Sebapoznanie',
        description: 'Silné stránky, motivácia, hodnoty a čo robiť s výsledkami testov.',
        icon: 'heart-outline',
        color: '#ec4899',
        darkColor: '#ec4899',
        bgColor: 'rgba(236,72,153,0.1)'
    }
] as const

export type DiscussionTopic = (typeof DISCUSSION_TOPICS)[number]
export type DiscussionTopicId = DiscussionTopic['id']

export const DISCUSSION_SORTS = ['hot', 'new'] as const
export type DiscussionSort = (typeof DISCUSSION_SORTS)[number]

export const DISCUSSION_TITLE_MIN_LENGTH = 10
export const DISCUSSION_TITLE_MAX_LENGTH = 160
export const DISCUSSION_BODY_MAX_LENGTH = 5000
export const DISCUSSION_COMMENT_MAX_LENGTH = 2000

/** Public identity only: first name + last initial, never email or photo. */
export interface DiscussionAuthor {
    id: string
    name: string
}

export interface DiscussionSummary {
    /** The document ID doubles as the URL slug. */
    slug: string
    topic: DiscussionTopicId
    title: string
    excerpt: string
    author: DiscussionAuthor
    upvotes: number
    commentCount: number
    createdAt: string
    lastActivityAt: string
}

export interface Discussion extends DiscussionSummary {
    body: string
    updatedAt: string | null
}

export interface DiscussionComment {
    id: string
    /** Always a top-level comment ID: replies are kept one level deep. */
    parentId: string | null
    /** Null once deleted; the comment stays as a placeholder while it has replies. */
    author: DiscussionAuthor | null
    content: string
    deleted: boolean
    createdAt: string
    updatedAt: string | null
}

export interface DiscussionCommentThread {
    comment: DiscussionComment
    replies: DiscussionComment[]
}

export interface DiscussionPage {
    discussion: Discussion
    comments: DiscussionComment[]
}

export interface DiscussionList {
    items: DiscussionSummary[]
    nextCursor: string | null
}

export interface DiscussionViewerState {
    upvoted: boolean
    canModerate: boolean
}

export interface DiscussionVoteResult {
    upvoted: boolean
    upvotes: number
}
